import { API_URL } from "config";
import Http from "util/https";
import { ShopAddressInfo, ShopAddressInfoResponseApi, WholeShop, WholeShopResponseApi } from "../types";

/**
 * 店舗の住所取得Api
 * @param clientCd 得意先コード
 * @returns レスポンスデータ
 */
export default async function getShopAddressInfo(clientCd?: string): Promise<ShopAddressInfo> {
  const params: {} | {clientCd: string} = clientCd ? {client_cd: clientCd} : {};
  const http = Http.default.alterAuth({ useToken: true });
  const url = `${API_URL}/order/client/address`;
  const res = await http.post<ShopAddressInfoResponseApi>(url, params);
  console.log(res);

  await new Promise<void>((resolve) => {setTimeout(resolve, 1500)});

  // const res: {data: ShopAddressInfoResponseApi} = {data: {
  //   shipping_zip: "000-0000",
  //   shipping_address: "埼玉県戸田市美女木北２－１－１７",
  //   shipping_phone: "000-0000-0000",
  //   shipping_name: "美女木店",
  // }};

  const shopInfo: ShopAddressInfo = {
    postalCd: res.data.shipping_zip ?? '',
    address: res.data.shipping_address,
    phoneNumber: res.data.shipping_phone,
    destinationName: res.data.shipping_name,
  };

  return shopInfo;
}
